module.exports = __webpack_public_path__ + "img/bgc12.afcf6df0.png";